
export enum CommunicationChannel {
    Voice = 'Voice',
    Chat = 'Chat'
}
